var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcademy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85004 9.625C5.78254 9.625 5.71504 9.63594 5.65035 9.65508C5.28754 9.76992 4.90504 9.84375 4.50004 9.84375C4.09504 9.84375 3.71254 9.76992 3.34691 9.65508C3.28223 9.63594 3.21473 9.625 3.14723 9.625C1.40348 9.625 -0.00839988 11.0059 3.76214e-05 12.7039C0.00285012 13.423 0.61035 14 1.35004 14H7.65004C8.38973 14 8.99723 13.423 9.00004 12.7039C9.00848 11.0059 7.5966 9.625 5.85004 9.625ZM4.50004 8.75C5.99066 8.75 7.20004 7.57422 7.20004 6.125C7.20004 4.67578 5.99066 3.5 4.50004 3.5C3.00941 3.5 1.80004 4.67578 1.80004 6.125C1.80004 7.57422 3.00941 8.75 4.50004 8.75ZM16.65 0H5.85004C5.10473 0 4.50004 0.609766 4.50004 1.35625V2.625C5.15816 2.625 5.76848 2.81094 6.30004 3.11172V1.75H16.2V9.625H14.4V7.875H10.8V9.625H8.65691C9.1941 10.0816 9.58785 10.6832 9.77348 11.375H16.65C17.3954 11.375 18 10.7652 18 10.0188V1.35625C18 0.609766 17.3954 0 16.65 0Z",
    fill: "#082c3f"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademy);
export default __webpack_public_path__ + "static/media/academy.d8d084160c2c01c25e2fd77dc619d354.svg";
export { ForwardRef as ReactComponent };